<template>
    <section>
      <header class="mui-bar mui-bar-nav">
        <a class="mui-action-back mui-icon mui-icon-left-nav mui-pull-left"></a>
        <h1 class="mui-title">原料信息录入</h1>
      </header>
      <div class="mui-content">
        <div style="padding-top: 10px;">
          <!--第一行-->
          <div class="form-group">
            <div class="input-label">
              <label >供应商:</label>
            </div>
            <div class="form-input">
              <input type="text"/>
            </div>

          </div>
          <div class="form-group">
            <div class="input-label">
              <label >品号:</label>
            </div>
            <div class="form-input">
              <input type="text"/>
            </div>
          </div>
          <div class="form-group">
            <div class="input-label">
              <label >批号:</label>
            </div>
            <div class="form-input">
              <input type="text"/>
            </div>
          </div>
          <div class="form-group">
            <label class="input-label" >数量</label>
            <div class="form-input">
              <input type="text"/>
            </div>
          </div>
          <div class="form-group">
            <label class="input-label" >生产日期:</label>
            <div class="form-input" style="display: flex;">
              <input type="text" style="flex: 1;" id="pickDateBtn"/>
              <span class="input-label" style="flex:1;">

			    		</span>
            </div>
          </div>
          <div class="form-group">
            <label class="input-label" >等级</label>
            <div class="form-input" style="display: flex;">
              <input type="text" style="flex: 1;"/>
              <span class="input-label" style="flex:1;">

			    		</span>
            </div>
          </div>
          <div class="form-group">
            <label class="input-label" >经纬区分:</label>
            <div class="form-input" style="display: flex;padding-top: 4px;">
              <div class="mui-input-row mui-radio mui-left">
                <input name="radio1" type="radio" checked="checked" style="vertical-align: middle;">
                <label  style="vertical-align: middle;" >经</label>
              </div>
              <div class="mui-input-row mui-radio mui-left">
                <input name="radio1" type="radio">
                <label>纬</label>
              </div>
            </div>
          </div>
          <div class="form-group" style="width:100%;margin-top: 30px;">
            <button type="button" class="mui-btn mui-btn-primary" style="margin: auto;width: 80px;">确定</button>
            <button type="button" class="mui-btn mui-btn-default" style="margin: auto;width: 80px;" @click="goback">取消</button>
          </div>
        </div>
      </div>
    </section>
</template>

<script>
    export default {
        name: "materialEntry",
        methods:{
          goback: function() {
            this.$router.go(-1);
          }
        }
    }
</script>

<style scoped>
  @import "../../static/css/filterorder.css";
</style>



// WEBPACK FOOTER //
// src/components/materialEntry.vue